import { createContext } from "react";

import { IContextLanguage } from "./language.types";

export const ContextLanguage = createContext<IContextLanguage>(
  null as unknown as IContextLanguage,
);
